import { UserNotFoundPage } from 'modules/accounts/account-details';
import { useIndexUsers } from 'modules/accounts/accounts.queries';
import { useAuth } from 'modules/auth/auth.context';
import { LoadingPage } from 'modules/pages/loading-page';
import * as React from 'react';
import { useQuery } from 'react-query';
import { Redirect } from 'react-router-dom';
import { SearchUserOptions } from 'services/api-ops.service';

enum ZendeskIdentityTypeEnum {
  EMAIL = 'email',
  PHONE_NUMBER = 'phone_number',
}

export function MainPage() {
  const { zendeskClient } = useAuth();
  // const [requester, setRequester] = React.useState<any>();
  const { data: requesterInfo } = useQuery(
    ['get_requester'],
    () => zendeskClient.get('ticket.requester') as Promise<any>,
    {
      enabled: !!zendeskClient,
    }
  );
  const [searchQuery, setSearchQuery] = React.useState<SearchUserOptions>();
  const [customerIdentities, setCustomerIdentities] = React.useState<
    ZendeskCustomerQuery[]
  >([]);
  // empty = false, not done or half-done = true, done = false
  const checkedAllIdentities = React.useMemo(
    () => customerIdentities.some((identity) => identity.isSearched === false),
    [customerIdentities]
  );

  const { data, isLoading } = useIndexUsers(
    { perPage: 20, page: 1, search: { ...searchQuery } },
    {
      enabled: !!searchQuery,
      onSuccess: (data) => {
        /** loop thru all emails and phone number */

        if (data.isEmpty && checkedAllIdentities) {
          let flag = false;
          setCustomerIdentities((prev) =>
            prev.map((identity) => {
              if (!flag && !identity.isSearched) {
                flag = true;
                return { ...identity, isSearched: true };
              }
              return identity;
            })
          );
        }
      },
      select: (data) => {
        if (data.items.length > 1) {
          /** use exact filter */
          const exactCustomer = data.items.find(
            (customer) =>
              customer.phone === searchQuery?.phone ||
              customer.phone === '6' + searchQuery?.phone
          );
          return { ...data, items: exactCustomer ? [exactCustomer] : [] };
        }

        return data;
      },
    }
  );

  React.useEffect(() => {
    if (customerIdentities.length) {
      customerIdentities.some((identity) => {
        if (identity.isSearched) {
          return false;
        }
        switch (identity.type) {
          case ZendeskIdentityTypeEnum.EMAIL:
            setSearchQuery({ email: identity.value });

            return true;
          case ZendeskIdentityTypeEnum.PHONE_NUMBER:
            setSearchQuery({ phone: identity.value });
            return true;
          default:
            return false;
        }
      });
    }
  }, [customerIdentities]);

  React.useEffect(() => {
    /**
     * - FIRST Check email
     * - then check phone number
     */
    if (
      requesterInfo &&
      requesterInfo['ticket.requester'].identities.length
      // requester['ticket.requester'].identities[0].type === ZendeskIdentityTypeEnum.EMAIL
    ) {
      setCustomerIdentities(
        (
          requesterInfo['ticket.requester'].identities as Array<ZendeskIdentity>
        ).reduce(
          (acc: ZendeskCustomerQuery[], current) => [
            ...acc,
            {
              type: current.type,
              value: current.value,
              isSearched: false,
            },
          ],
          []
        )
      );
      // sort by alphabet, so that will query email first
      // .sort((a, b) => (a.type < b.type ? -1 : -1)) // query sequence: 1. email 2. phone_number
    }
  }, [requesterInfo]);

  return (
    <>
      {zendeskClient ? (
        <div>
          {!checkedAllIdentities && requesterInfo && <UserNotFoundPage />}
          {data && data.items.length === 1 && (
            <Redirect to={`/accounts/${data?.items[0].userId}`}></Redirect>
          )}
        </div>
      ) : (
        <div>Not embedded into zendesk app</div>
      )}
      {isLoading || checkedAllIdentities ? <LoadingPage /> : null}
    </>
  );
}

interface ZendeskIdentity {
  type: ZendeskIdentityTypeEnum;
  value: string;
}

interface ZendeskCustomerQuery extends ZendeskIdentity {
  isSearched: boolean;
}
